import { useTranslation } from 'react-i18next';
import type { Screen } from '@ghostscreen/contracts';

type PlaylistDrawerScreensProps = {
  screens: Screen[];
  assignedScreenIds: ReadonlySet<string>;
  busy: boolean;
  onToggle: (screen: Screen, currentlyOn: boolean) => void;
};

export function PlaylistDrawerScreens({
  screens,
  assignedScreenIds,
  busy,
  onToggle,
}: PlaylistDrawerScreensProps) {
  const { t } = useTranslation('playlists');
  if (screens.length === 0) {
    return (
      <p className="m-0 text-[13.5px]" style={{ color: 'var(--gs-muted)' }}>
        {t('screens.empty')}
      </p>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {screens.map((screen) => {
        const on = assignedScreenIds.has(screen.id);
        return (
          <button
            key={screen.id}
            type="button"
            disabled={busy}
            onClick={() => onToggle(screen, on)}
            className="inline-flex items-center gap-2 rounded-full border-[1.5px] px-3.5 py-2 text-[13.5px] font-semibold transition hover:border-[var(--gs-accent)] disabled:opacity-50"
            style={{
              color: on ? 'var(--gs-ink)' : 'var(--gs-ink2)',
              background: on ? 'var(--gs-panel2)' : 'transparent',
              borderColor: on ? 'var(--gs-accent)' : 'var(--gs-line)',
            }}
          >
            <span className="font-extrabold" style={{ color: 'var(--gs-accent)' }}>
              {on ? '✓' : '+'}
            </span>
            {screen.name}
          </button>
        );
      })}
    </div>
  );
}
